import { Component, OnInit } from '@angular/core';
import ApexCharts from 'apexcharts';
import { ResponseObject } from 'src/app/models/response-object.model';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { AccountingReportService } from 'src/app/services/reports/accounting-report.service';
import { DateUtil } from 'src/app/common/util';
import { WarehouseService } from 'src/app/services/warehouse.service';
import { WarehouseResponse } from 'src/app/models/warehouse.model';

@Component({
  selector: 'app-sale-detail-chart',
  templateUrl: './sale-detail-chart.component.html',
  styleUrls: ['./sale-detail-chart.component.scss']
})
export class SaleDetailChartComponent implements OnInit {
  start: any = "";
  end: any = "";
  warehouse = null;
  warehouses: WarehouseResponse[] = [];
  warehousesName: { [key: number]: string } = {};
  dataChart = null;
  categoriesChart = null;
  loadingChart = false;
  results = [];

  constructor(
    private toastService: ToastrService,
    private accountingService: AccountingReportService,
    private warehouseService: WarehouseService
  ) {
    var today = new Date(DateUtil.getActualDate());
    this.end = DateUtil.getActualDate().split('T')[0];
    today.setDate(today.getDate() - 30);
    var other = new Date(today);
    var convert = DateUtil.parseDateToMilliseconds(other.toISOString());
    this.start = new Date(convert).toLocaleDateString('en-CA');
  }

  ngOnInit(): void {
    this.getWarehouses();
  }

  getWarehouses() {
    this.warehouseService.getWarehouseByClue('').subscribe({
      next: (response: ResponseObject) => {
        this.warehouses = response.data;
        this.warehouses.forEach((w) => {
          this.warehousesName[w.id] = w.name;
        });
        this.updateChart();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  updateChart() {
    document.getElementById("sale-detail-chart").innerHTML = "";
    this.loadingChart = true;
    if (this.warehouse != -1) {
      this.accountingService.getSaleDetailWarehouses(
        this.warehouse,
        DateUtil.parseDateToMilliseconds(this.start),
        DateUtil.parseDateToMilliseconds(this.end)
      ).subscribe({
        next: (response: ResponseObject) => {
          var data = [];
          var detail = { name: 'Venta', data: [] };
          var invoice = { name: 'Facturación', data: [] };
          var categories = [];
          this.results = response.data;
          response.data.forEach((r) => {
            detail.data.push(r.total_detail);
            invoice.data.push(r.total_invoice);
            categories.push(this.warehousesName[r.warehouse]);
          });
          data.push(detail);
          data.push(invoice);
          this.dataChart = data;
          this.categoriesChart = categories;
          this.getChart();
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.error(error.error.message);
          this.loadingChart = false;
        }
      })
    } else {
      this.accountingService.getSaleDetailGeneral(
        DateUtil.parseDateToMilliseconds(this.start),
        DateUtil.parseDateToMilliseconds(this.end)
      ).subscribe({
        next: (response: ResponseObject) => {
          var data = [];
          var detail = { name: 'Venta', data: [] };
          var invoice = { name: 'Facturación', data: [] };
          var categories = [];
          this.results = response.data;
          response.data.forEach((r) => {
            detail.data.push(r.total_detail);
            invoice.data.push(r.total_invoice);
            categories.push('TOTAL TODAS LAS BODEGAS');
          });
          data.push(detail);
          data.push(invoice);
          this.dataChart = data;
          this.categoriesChart = categories;
          setTimeout(() => {
            this.getChart();
          }, 100);
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.error(error.error.message);
          this.loadingChart = false;
        }
      })
    }
  }

  getChart() {
    var data = this.dataChart;
    var categories = this.categoriesChart;
    var options = {
      series: data,
      chart: {
        height: 350,
        type: 'bar',
        events: {
          click: function (chart, w, e) {
            // console.log(chart, w, e)
          }
        }
      },
      plotOptions: {
        bar: {
          columnWidth: '45%'
        }
      },
      dataLabels: {
        enabled: false
      },
      xaxis: {
        categories: categories
      },
      tooltip: {
        custom: function ({ series, seriesIndex, dataPointIndex, w }) {
          console.log(series, seriesIndex, dataPointIndex, w);

          var data = w.globals.initialSeries[seriesIndex].data[dataPointIndex];

          return '<div style="padding:0.5em; margin:0;"><p class="h6">' + w.globals.labels[dataPointIndex] + '<span style="color:' + w.globals.colors[dataPointIndex] + ';">⬤</span></p>' +
            '<p class="h4" style="color:' + w.globals.colors[dataPointIndex] + ';"><b>Q ' + new Intl.NumberFormat('en-US').format(series[seriesIndex][dataPointIndex]) + '</b></p></div>';
        }
      }
    };
    this.loadingChart = false;

    var chart = new ApexCharts(document.querySelector("#sale-detail-chart"), options);
    chart.render();
  }
}
